// extracted by mini-css-extract-plugin
module.exports = {"chipRootEditable":"FieldMultiChipValue_chipRootEditable__whvIM","chipRootReadOnly":"FieldMultiChipValue_chipRootReadOnly__SFmqN"};